import React, { ReactElement } from 'react';
import { ListItemIcon, MenuItem, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * Composant gérant les éléments de menu
 * @param props Contient le nom de l'item, le lien à y attribuer, le comportement au clic et l'icône de l'élément de menu
 * @constructor
 */
export default function MenuHeaderItem(props: {
    text: string;
    href: string | null;
    handle: () => void;
    icon: ReactElement;
}): JSX.Element {
    let menuItem = (
        <>
            <ListItemIcon>{props.icon}</ListItemIcon>
            <Typography variant="h6" sx={{ marginTop: '3px' }}>
                {props.text}
            </Typography>
        </>
    );

    return props.href !== null ? (
        <MenuItem onClick={props.handle} component={Link} to={props.href}>
            {menuItem}
        </MenuItem>
    ) : (
        <MenuItem onClick={props.handle}>{menuItem}</MenuItem>
    );
}
